/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResearchGleifResponseDto,
} from '../models/index';
import {
    ResearchGleifResponseDtoFromJSON,
    ResearchGleifResponseDtoToJSON,
} from '../models/index';

export interface SearchByLeiRequest {
    lei: string;
}

/**
 * 
 */
export class SearchControllerApi extends runtime.BaseAPI {

    /**
     * Search Org by LEI
     */
    async searchByLeiRaw(requestParameters: SearchByLeiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResearchGleifResponseDto>> {
        if (requestParameters['lei'] == null) {
            throw new runtime.RequiredError(
                'lei',
                'Required parameter "lei" was null or undefined when calling searchByLei().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/org/search/{lei}`.replace(`{${"lei"}}`, encodeURIComponent(String(requestParameters['lei']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResearchGleifResponseDtoFromJSON(jsonValue));
    }

    /**
     * Search Org by LEI
     */
    async searchByLei(requestParameters: SearchByLeiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResearchGleifResponseDto | null | undefined > {
        const response = await this.searchByLeiRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

}
